import React from 'react';
import TableType2 from 'src/components/sharedComponents/Tablas/TableType2/TableType2';
import { permitsList } from 'src/constants/permits';
import CardTitle from 'src/components/sharedComponents/CardTitle';

const LaunchPage = (props) => {
  const {
    releases, loading, permisos, onChangeState,
  } = props;

  const columns = [
    { title: 'Linea', field: 'LINEA', editable: 'never' },
    { title: 'Lanzamiento', field: 'LANZAMIENTO', editable: 'never' },
  ];

  return (
    <>
      <CardTitle title="Tabla de Lanzamientos" />
      <TableType2
        dataTable={releases}
        isSelection
        isEditHidden
        onSelectRow={onChangeState}
        idPermiso={permitsList.LANZAMIENTOS_REPORTES}
        minValue={permisos[permitsList.LANZAMIENTOS_REPORTES]}
        columns={columns}
        loading={loading}
        title
      />
    </>
  );
};

export default LaunchPage;
